import { render, staticRenderFns } from "./MultipleImageCtaSection.vue?vue&type=template&id=b5066c6c&scoped=true&"
import script from "./MultipleImageCtaSection.vue?vue&type=script&lang=js&"
export * from "./MultipleImageCtaSection.vue?vue&type=script&lang=js&"
import style0 from "./MultipleImageCtaSection.vue?vue&type=style&index=0&id=b5066c6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5066c6c",
  null
  
)

export default component.exports